import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { UsuarioEmailAdministrativoSelectModule } from '../../../usuario/email/administrativo/select';

import { SendEmailModalComponent } from './send-email-modal.component';

@NgModule({
    imports: [
        SharedModule,
        UsuarioEmailAdministrativoSelectModule
    ],
    declarations: [
        SendEmailModalComponent
    ],
    exports: [
        SendEmailModalComponent
    ]
})
export class SendEmailModalModule { }
